import React from 'react';
import PropTypes from 'prop-types';

const WorkersIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 13.716">
        <path d="M16 7.145a2.573 2.573 0 00-5.142-.2 4 4 0 00-.914-.708 3.428 3.428 0 10-3.931 0 4 4 0 00-.868.708 2.565 2.565 0 10-4.165 2.2 2.56 2.56 0 00-.977 2v2a.571.571 0 00.571.571h14.853a.571.571 0 00.573-.571v-2a2.56 2.56 0 00-.977-2 2.56 2.56 0 00.977-2zM5.714 3.432A2.285 2.285 0 118 5.717a2.285 2.285 0 01-2.286-2.285zM1.143 7.145a1.428 1.428 0 111.428 1.428 1.428 1.428 0 01-1.428-1.428zm0 4a1.428 1.428 0 012.857 0v1.428H1.143zm4 0V9.717a2.857 2.857 0 015.714 0v2.857H5.142zm9.713 0v1.428H12v-1.428a1.428 1.428 0 012.857 0zm-2.857-4a1.428 1.428 0 111.428 1.428A1.428 1.428 0 0112 7.145z" fill={fill} />
    </svg>
);

WorkersIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

WorkersIcon.defaultProps = {
    width: '16',
    height: '13.716',
    fill: '#4b254e'
};

export default WorkersIcon;
